// API Configuration - Load from environment variables
export const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:3000';

// NOTE: The external AI service (extract / extract-simple / simplify) is reached
// ONLY through the backend proxy (/ai-recipe/*). Its URL lives on the backend
// (EXTRACT_SERVICE_URL env) and is never shipped in the frontend bundle.

// Environment
export const NODE_ENV =
  import.meta.env.VITE_NODE_ENV || import.meta.env.MODE || 'development';

// Token storage keys
export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const USER_KEY = 'user';
